import { useState } from "react";

import {
  VerificationTemplate,
  VerificationTemplatesContext,
  initialVerificationTemplateValues,
} from "./VerificationTemplatesContext";
import { VerificationTemplateDetails } from "./steps/VerificationTemplateDetails";
import { VerificationTemplateType } from "./steps/VerificationTemplateType";
import { useSteps } from "../../../hooks/useSteps";
import { useFlags } from "launchdarkly-react-client-sdk";

export function VerificationTemplatesPage() {
  const { currentStep, handleNext, handlePrev } = useSteps(0);
  const { releaseInstantEmploymentVerification } = useFlags();
  const [verificationTemplate, setVerificationTemplate] =
    useState<VerificationTemplate>({
      ...initialVerificationTemplateValues,
      check_arguments: {
        ...initialVerificationTemplateValues.check_arguments,
        digital_verification: !!releaseInstantEmploymentVerification,
      },
    });

  const steps = [
    <VerificationTemplateType key="type" />,
    <VerificationTemplateDetails key="details" />,
  ];

  return (
    <VerificationTemplatesContext.Provider
      value={{
        verificationTemplate,
        setVerificationTemplate,
        isLastStep: currentStep >= steps.length - 1,
        numberOfSteps: steps?.length,
        goToNextStep: handleNext,
        goToPrevStep: handlePrev,
        currentStep,
      }}
    >
      {steps[currentStep]}
    </VerificationTemplatesContext.Provider>
  );
}
